<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Observación</label>
            <textarea v-model="form.observation" rows="3"
              class="form-input mt-1 w-full"
              :class="form.errors.observation ? 'error' : ''">
            </textarea>
            <div v-if="form.errors.observation" class="form-error">{{ form.errors.observation }}</div>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Tipo de Soporte</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Crear Tipo de Soporte' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        observation: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('support_types.store'))
    },
  },
}
</script>
